<template>
  <div id="app">
    <!--
    缓存数据，利用exclude刨除不需要缓存的组件，
    activated,deactivated这两个生命周期函数
    一定是要在使用了keep-alive组件后才会有的，
    使用exclude后则无效。
    -->
    <keep-alive
      :exclude="['AddressList', 'AddressInfo', 'Login', 'productDetail','orderDetail', 'logistics', 'orderFinish', 'couponList', 'vip', 'memberCard', 'paymentCenter', 'customServiceLanding', 'orderList', 'productList']"
    >
      <!--当前路由地址所对应的内容-->
      <router-view :key="$route.fullPath"/>
    </keep-alive>
  </div>
</template>

<script>
import axios from "@/api/axios";
import { mapState } from "vuex";
import Utils from "@/utils/util";
import MobileDetect from "mobile-detect";
import sensors from "sa-sdk-javascript";
import queryStr from 'query-string-es5';
import { pushSensorsInit } from './utils/sensors.js'
import service from '@/utils/wx_service'
export default {
  name: "App",
  created() {
    if (localStorage.userInfo&&localStorage.userInfo!=='{}') {
      let userInfo = JSON.parse(localStorage.userInfo)
      let data = {
        user_type: userInfo.userType,
        user_level: userInfo.userLevel,
        nick_name: userInfo.nickName,
        lolatitude: ''
      }
      pushSensorsInit(userInfo.userId, data)
    }else{
      pushSensorsInit()
    }

    console.log(location.search, '----==-=-==')

    let shareData = {}
    if (window.location.href.indexOf('productDetail') > -1 && queryStr.parse(location.search).ipt == 4) {
      shareData.share_id = queryStr.parse(location.search).rc
      shareData.sku_id = queryStr.parse(location.search).sku;
      shareData.share_type = 3;
      shareData.item_prom_type = 4;
    } else if (window.location.href.indexOf('materialDetail') > -1) {
      shareData.share_type = 20;
      if (queryStr.parse(location.search).ipt == 4) {
        shareData.item_prom_type = 4;
      }
      shareData.materialId = queryStr.parse(location.search).materialId;
      shareData.share_id = queryStr.parse(location.search).rc
    }

    console.log(shareData)

    sensors.track("shareBack", shareData)

    var md = new MobileDetect(window.navigator.userAgent);
    let sessionId = `${axios.query.v}${Date.now()}`;
    let entry_time = `${Utils.formatTime2(Date.now(), "yyyy-MM-dd hh:mm:ss")}`;
    let version = axios.query.v;
    let platform = axios.query.p;
    let device = md.phone();
    let os = md.os();
    if (os == "iOS") {
      //ios系统的处理
      os = md.os() + " " + md.version("iPhone");
    } else if (os == "AndroidOS") {
      //Android系统的处理
      os = md.os() + " " + md.version("Android");
    }
    console.log(os);
    let buriedPoint = {
      sessionId,
      entry_time,
      version,
      platform,
      device,
      os
    };
    localStorage.buriedPoint = JSON.stringify(buriedPoint);
    axios
      .POST("getCDNFormat",{isHideLoading: true})
      .then(res => {
        if (res.code === 0) {
          this.$store.commit("changeCDNFormat", res.data);
          localStorage.CDNFormat = JSON.stringify(res.data);
        }
      })
      .catch(err => {
        console.warn(err);
      });
    if (Utils.isWxWebEnv) {
        // 微信公众号分享 todo
        this.getWeixinTicket({
            url: window.location.href
        }).then((data) => {
            service.wxConfig(data)
        })
    }

  },
  mounted() {
    this.setUtmPonitParams()
  },
  methods: {
    setUtmPonitParams(){ //设置神策用UTM参数 如果有就存起来，没有就不存，存session
            console.log('queryStr',queryStr.parse(window.location.search))
            let queryData = queryStr.parse(window.location.search)
            if(queryData.utm_campaign){
              let utmParams = {
                utm_campaign: queryData.utm_campaign || '',
                utm_medium: queryData.utm_medium || '',
                utm_source: queryData.utm_source || '',
                utm_term: queryData.utm_term || ''
              }
              sessionStorage.setItem('utmParams', JSON.stringify(utmParams))
            }
            //sessionStorage.getItem('utmParams')
        },
    /**
     * 微信环境获取公众号相关细节
     */
    getWeixinTicket(data) {
        return new Promise((resolve, reject) => {
            axios.GET('getWeixinTicket', data).then(res => {
                if (res.code === 0) {
                    resolve(res.data)
                } else {
                    reject()
                }
            }).catch(err => {
                reject(err)
            })
        })
    },
  },
};
</script>
<style lang='stylus' scoped></style>



// WEBPACK FOOTER //
// src/App.vue